"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _filesize = _interopRequireDefault(require("filesize"));

var _Chip = _interopRequireDefault(require("../Chip"));

var AttachmentChip = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var fileName = _ref.fileName,
      size = _ref.size,
      _onClick = _ref.onClick,
      thumbnail = _ref.thumbnail;
  return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
    thumbnail: thumbnail,
    onClick: function onClick(e) {
      e.stopPropagation();

      _onClick();
    },
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "truncate w-40 font-semibold",
    title: fileName
  }, fileName), /*#__PURE__*/_react["default"].createElement("div", null, (0, _filesize["default"])(size)));
});
var _default = AttachmentChip;
exports["default"] = _default;
//# sourceMappingURL=index.js.map